import { Controller, Post, Body, Req } from '@nestjs/common';
import { EmployeeTypesResponseModel, AllEmployeeTypesResponse } from '@gtpl/shared-models/hrms';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ApiTags } from '@nestjs/swagger';
import { EmployeeTypesDTO } from './dto/employee-type.dto';
import { EmployeeTypesIdRequest } from './dto/employee-type.request';
import { EmployeeTypesService } from './employee-type.service';


@ApiTags('employeeTypes')
@Controller('employeeTypes')
export class EmployeeTypesController {

    constructor(
        private service: EmployeeTypesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
    ){}

    @Post('/createEmployeeTypes')
    async createEmployeeTypes(@Body() DTO: EmployeeTypesDTO, isUpdate: boolean = false): Promise<EmployeeTypesResponseModel>{
        try{
            return await this.service.createEmployeeTypes(DTO, false);
        }catch(error){
            return this.applicationExceptionHandler.returnException(EmployeeTypesResponseModel, error);
        }
    }

    @Post('/updateEmployeeTypes')
    async updateEmployeeTypes(@Body() DTO: EmployeeTypesDTO, isUpdate: boolean = false): Promise<EmployeeTypesResponseModel>{
        try{
            return await this.service.createEmployeeTypes(DTO, true);
        }catch(error){
            return this.applicationExceptionHandler.returnException(EmployeeTypesResponseModel, error);
        }
    }

    @Post('/getAllEmployeeTypes')
    async getAllEmployeeTypes(): Promise<AllEmployeeTypesResponse>{
        try{
            return await this.service.getAllEmployeeTypes();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllEmployeeTypesResponse, error);
        }
    }

    @Post('/getAllActiveEmployeeTypes')
    async getAllActiveEmployeeTypes(): Promise<AllEmployeeTypesResponse>{
        try{
            return await this.service.getAllActiveEmployeeTypes();
        }catch(error){
            return this.applicationExceptionHandler.returnException(AllEmployeeTypesResponse, error);
        }
    }

    @Post('/activateOrDeactivate')
    async activateOrDeactivate(@Body() req: EmployeeTypesIdRequest): Promise<EmployeeTypesResponseModel>{
        try{
            return await this.service.activateOrDeactivateEmployeeTypes(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(EmployeeTypesResponseModel, error);
        }
    }

    @Post('/getEmployeeTypesById')
    async getEmployeeTypesById(@Body() req: EmployeeTypesIdRequest): Promise<EmployeeTypesResponseModel>{
        try{
            return await this.service.getEmployeeTypesById(req);
        }catch(error){
            return this.applicationExceptionHandler.returnException(EmployeeTypesResponseModel, error);
        }
    }
}
